// Copyright (c) 2016 Deere & Company

import claimProcessInvoice from './claim-process-invoice';
import massProcessInvoice from './mass-process-invoice';

export default {

    childRoutes: [
        claimProcessInvoice,
        massProcessInvoice
    ],
    indexRoute: {onEnter: (nextState, replace) => replace('/claims/dealer-invoices')},
    name: 'DEALER_INVOICES',
    path: 'invoice-details'

};



// WEBPACK FOOTER //
// ./src/routes/claims/invoice-details/index.js